module.exports = __webpack_public_path__ + "img/Thumbnail_LandBased.69ad9b13.png";